export interface Category {
  id: string;
  nameKey: string;
  link: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'home.catShoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20with%20subtle%20green%20accents%20placed%20on%20a%20rough%20concrete%20floor%2C%20natural%20window%20light%20casting%20soft%20shadows%2C%20editorial%20fashion%20product%20photography%20with%20warm%20neutral%20tones&width=600&height=600&seq=cat-shoes-01&orientation=squarish',
  },
  {
    id: 'hoodies',
    nameKey: 'home.catHoodies',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20oversized%20heather%20gray%20hoodie%20draped%20over%20a%20vintage%20wooden%20chair%20with%20warm%20ambient%20lamp%20light%2C%20soft%20textured%20knit%20fabric%20detail%2C%20editorial%20fashion%20photography%20with%20earthy%20warm%20tones&width=600&height=600&seq=cat-hoodies-02&orientation=squarish',
  },
  {
    id: 'tshirts',
    nameKey: 'home.catTshirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Crisp%20white%20organic%20cotton%20t-shirt%20hanging%20on%20a%20minimalist%20brass%20clothing%20rack%20against%20a%20textured%20linen%20backdrop%2C%20soft%20side%20lighting%2C%20clean%20editorial%20fashion%20photography%20with%20natural%20warm%20tones&width=600&height=600&seq=cat-tshirts-03&orientation=squarish',
  },
  {
    id: 'jackets',
    nameKey: 'home.catJackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20black%20metal%20coat%20hook%20against%20a%20pale%20terracotta%20wall%2C%20urban%20streetwear%20aesthetic%2C%20soft%20warm%20lighting%20from%20the%20side%2C%20high%20detail%20editorial%20photography&width=600&height=600&seq=cat-jackets-04&orientation=squarish',
  },
  {
    id: 'pants',
    nameKey: 'home.catPants',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20beige%20chino%20trousers%20and%20dark%20denim%20shorts%20stacked%20on%20a%20white%20marble%20surface%20with%20a%20small%20leather%20belt%2C%20clean%20editorial%20product%20styling%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones&width=600&height=600&seq=cat-pants-05&orientation=squarish',
  },
  {
    id: 'headwear',
    nameKey: 'home.catHeadwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Classic%20navy%20baseball%20cap%20resting%20on%20a%20light%20oak%20wood%20block%20with%20soft%20natural%20window%20light%2C%20minimalist%20still%20life%20photography%2C%20clean%20warm%20neutral%20background%2C%20high%20detail%20textile%20texture&width=600&height=600&seq=cat-headwear-06&orientation=squarish',
  },
  {
    id: 'sets',
    nameKey: 'home.catSets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Coordinated%20matching%20tracksuit%20set%20in%20soft%20sage%20green%20neatly%20laid%20flat%20with%20sneakers%20and%20a%20canvas%20tote%20on%20a%20warm%20beige%20linen%20surface%2C%20athleisure%20editorial%20photography%20style%2C%20soft%20natural%20lighting&width=600&height=600&seq=cat-sets-07&orientation=squarish',
  },
  {
    id: 'underwear',
    nameKey: 'home.catUnderwear',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20briefs%20and%20boxers%20neatly%20folded%20on%20a%20blush%20pink%20velvet%20surface%20with%20a%20small%20eucalyptus%20sprig%2C%20intimate%20apparel%20editorial%20photography%2C%20soft%20diffused%20light%2C%20warm%20delicate%20tones&width=600&height=600&seq=cat-underwear-08&orientation=squarish',
  },
  {
    id: 'jersey',
    nameKey: 'home.catJersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Vibrant%20red%20and%20white%20sports%20basketball%20jersey%20with%20number%20print%20displayed%20on%20a%20minimal%20white%20mannequin%20torso%20against%20a%20light%20gray%20wall%2C%20athletic%20wear%20editorial%20photography%2C%20clean%20modern%20lighting&width=600&height=600&seq=cat-jersey-09&orientation=squarish',
  },
  {
    id: 'accessories',
    nameKey: 'home.catAccessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Curated%20mens%20fashion%20accessories%20collection%20with%20a%20minimalist%20watch%2C%20aviator%20sunglasses%2C%20slim%20leather%20wallet%20and%20silver%20bracelet%20arranged%20on%20a%20glass%20coffee%20table%20surface%2C%20soft%20overhead%20light%2C%20editorial%20luxury%20photography%20style&width=600&height=600&seq=cat-accessories-10&orientation=squarish',
  },
  {
    id: 'bags',
    nameKey: 'home.catBags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Stylish%20tan%20leather%20backpack%20hanging%20on%20a%20brass%20wall%20hook%20next%20to%20a%20small%20crossbody%20bag%20on%20a%20pale%20sage%20wall%2C%20fashion%20accessory%20editorial%20photography%2C%20soft%20natural%20window%20light%2C%20warm%20neutral%20palette&width=600&height=600&seq=cat-bags-11&orientation=squarish',
  },
  {
    id: 'belts',
    nameKey: 'home.catBelts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Handcrafted%20brown%20leather%20belt%20coiled%20neatly%20on%20a%20small%20white%20ceramic%20dish%20with%20brass%20buckle%20detail%20visible%2C%20soft%20side%20lighting%2C%20clean%20minimalist%20still%20life%20photography%20with%20warm%20earthy%20tones&width=600&height=600&seq=cat-belts-12&orientation=squarish',
  },
  {
    id: 'perfumes',
    nameKey: 'home.catPerfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20gold%20cap%20placed%20on%20a%20marble%20pedestal%20with%20a%20single%20dried%20flower%2C%20soft%20studio%20lighting%20creating%20warm%20highlights%2C%20luxury%20beauty%20editorial%20photography%20style&width=600&height=600&seq=cat-perfumes-13&orientation=squarish',
  },
  {
    id: 'other',
    nameKey: 'home.catOther',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Eclectic%20flat%20lay%20of%20assorted%20lifestyle%20products%20including%20a%20phone%20case%2C%20keychain%2C%20socks%20and%20a%20small%20notebook%20on%20a%20terrazzo%20surface%2C%20colorful%20but%20harmonious%20composition%2C%20soft%20natural%20light%2C%20modern%20editorial%20photography&width=600&height=600&seq=cat-other-14&orientation=squarish',
  },
];

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';